module.exports = __webpack_public_path__ + "img/board-star-3rd.29b35c33.svg";